module.exports = __webpack_public_path__ + "media/images/talent/mv-slider05-bd4ff880f12ee46b98a7b42add23aa28.png";